var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "print" } }, [
    _c(
      "div",
      { staticClass: "book m-auto" },
      _vm._l(
        Math.ceil(_vm.purchase.orders.length / _vm.maxOrderLists),
        function(data, idx) {
          return _c(
            "div",
            {
              key: idx,
              staticClass: "page",
              style: "font-size: " + _vm.fontSize + "%;"
            },
            [
              _c("div", { staticClass: "subpage" }, [
                _c("div", { staticClass: "top-header" }, [
                  idx == 0
                    ? _c("div", { staticClass: "company-info" }, [
                        _vm.shopInfo.logo.thumbnail
                          ? _c("img", {
                              attrs: { src: _vm.shopInfo.logo.thumbnail }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "name" }, [
                          _c("strong", { staticClass: "text-black" }, [
                            _vm._v(_vm._s(_vm.shopInfo.shop_name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "max-line-3" }, [
                            _vm._v(_vm._s(_vm.shopInfo.info.location.address))
                          ]),
                          _vm._v(" "),
                          _vm.shopInfo.info.vat.taxpayer_no
                            ? _c("p", { staticClass: "max-line-3" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("message.taxpayerno")) +
                                    ":\n                " +
                                    _vm._s(_vm.shopInfo.info.vat.taxpayer_no) +
                                    "\n              "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.getPartnerContact(_vm.shopInfo.contacts).tel
                            ? _c("p", { staticClass: "max-line-3" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("message.tel")) +
                                    ":\n                " +
                                    _vm._s(
                                      _vm.getPartnerContact(
                                        _vm.shopInfo.contacts
                                      ).tel
                                    ) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "document-type" }, [
                    _c("h2", { staticClass: "text-black" }, [
                      _vm._v(_vm._s(_vm.$t("documents.po")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.purchase.po_code))])
                  ])
                ]),
                _vm._v(" "),
                idx == 0
                  ? _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "left" }, [
                        _c("div", { staticClass: "section" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(_vm._s(_vm.$t("message.vendor")))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "detail" }, [
                            _vm._v(_vm._s(_vm.purchase.vendor.vendor_name))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.getPartnerContact(_vm.purchase.vendor.contacts).tel
                          ? _c("div", { staticClass: "section" }, [
                              _c("p", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.$t("message.tel")))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "detail" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getPartnerContact(
                                      _vm.purchase.vendor.contacts
                                    ).tel
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchase.vendor.address
                          ? _c("div", { staticClass: "section" }, [
                              _c("p", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.$t("message.address")))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "detail max-line-4" }, [
                                _vm._v(_vm._s(_vm.purchase.vendor.address))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchase.vendor.tax_id
                          ? _c("div", { staticClass: "section" }, [
                              _c("p", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.$t("message.taxpayerno")))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "detail" }, [
                                _vm._v(_vm._s(_vm.purchase.vendor.tax_id))
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right" }, [
                        _c("div", { staticClass: "section" }, [
                          _c("p", { staticClass: "label" }, [
                            _vm._v(_vm._s(_vm.$t("message.date")))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "detail" }, [
                            _vm._v(_vm._s(_vm.getDate(_vm.purchase.created_at)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section" },
                          [
                            _c("p", { staticClass: "label" }, [
                              _vm._v(_vm._s(_vm.$t("message.credittype")))
                            ]),
                            _vm._v(" "),
                            [
                              _vm.purchase.credit.type == "cash"
                                ? _c("p", { staticClass: "detail" }, [
                                    _vm._v(_vm._s(_vm.$t("message.cash")))
                                  ])
                                : _c("p", { staticClass: "detail" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.creditdasys", {
                                          number: _vm.purchase.credit.days
                                        })
                                      )
                                    )
                                  ])
                            ]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.purchase.credit.type == "days"
                          ? _c("div", { staticClass: "section" }, [
                              _c("p", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.$t("message.scheduled_at")))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "detail" }, [
                                _vm._v(
                                  _vm._s(_vm.getDate(_vm.purchase.scheduled_at))
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.refCodes.length
                          ? _c("div", { staticClass: "section" }, [
                              _c("p", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.$t("message.reference")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "detail",
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column"
                                  }
                                },
                                _vm._l(_vm.refCodes, function(refCode, index) {
                                  return _c("span", { key: index }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(refCode) +
                                        "\n                "
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "order" }, [
                  _c("table", [
                    _c("thead", [
                      _c("tr", [
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c("td", [
                          _c("b", [
                            _vm._v(_vm._s(_vm.$t("message.description")))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("b", [_vm._v(_vm._s(_vm.$t("message.quantity")))])
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-right",
                            staticStyle: { "min-width": "100px" }
                          },
                          [
                            _c("b", [
                              _vm._v(_vm._s(_vm.$t("message.unitprice")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.total.discount > 0 && _vm.foundDiscount
                          ? _c("td", { staticClass: "text-right" }, [
                              _c("b", [
                                _vm._v(_vm._s(_vm.$t("message.discount")))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("b", [_vm._v(_vm._s(_vm.$t("message.total")))])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.groupOrders[idx].orders, function(item, idx_) {
                        return _c("tr", { key: idx_ }, [
                          _c("td", { attrs: { width: "10px" } }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.maxOrderLists * idx + (idx_ + 1))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.description))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.getNumber(item.quantity)))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.getNumber(item.price)))
                          ]),
                          _vm._v(" "),
                          _vm.total.discount > 0 && _vm.foundDiscount
                            ? _c("td", { staticClass: "text-right" }, [
                                _vm.getDiscountInfo(item)
                                  ? _c(
                                      "span",
                                      [
                                        [
                                          _vm.getDiscountInfo(item).type ==
                                          "percentage"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getNumber(
                                                      _vm.getDiscountInfo(item)
                                                        .amount
                                                    )
                                                  ) + "%"
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getNumber(
                                                      _vm.getDiscountInfo(item)
                                                        .amount
                                                    )
                                                  ) +
                                                    " " +
                                                    _vm._s(_vm.currency)
                                                )
                                              ])
                                        ]
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(_vm.getNumber(_vm.getOrderTotal(item)))
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                ]),
                _vm._v(" "),
                Math.ceil(_vm.purchase.orders.length / _vm.maxOrderLists) > 0 &&
                idx !==
                  Math.ceil(_vm.purchase.orders.length / _vm.maxOrderLists) - 1
                  ? _c("div", { staticClass: "next-page" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.havenextpage")) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                idx >=
                Math.ceil(_vm.purchase.orders.length / _vm.maxOrderLists) - 1
                  ? _c("div", { staticClass: "footer" }, [
                      _c("div", { staticClass: "note" }, [
                        _vm.purchase.note
                          ? _c("div", { staticClass: "section" }, [
                              _c("p", [_vm._v(_vm._s(_vm.$t("message.note")))]),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "white-space": "normal",
                                    "word-wrap": "break-word",
                                    "overflow-wrap": "break-word"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.purchase.note))]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "total" }, [
                        _c(
                          "div",
                          { staticClass: "section" },
                          [
                            _vm.foundDiscount || _vm.foundTaxes
                              ? _c("div", { staticClass: "section row m-0" }, [
                                  _c("div", { staticClass: "label mb-2" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("message.total")) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "detail mb-2 text-right" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.getNumber(_vm.total.sub)) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.total.discount > 0 && _vm.foundDiscount
                              ? _c("div", { staticClass: "section row m-0" }, [
                                  _c("div", { staticClass: "label mb-2" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("message.discount")) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "detail mb-2 text-right" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getNumber(_vm.total.discount)
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.total.discount > 0 && _vm.foundDiscount
                              ? _c("div", { staticClass: "section row m-0" }, [
                                  _c("div", { staticClass: "label mb-2" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("message.discounted_total")
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "detail mb-2 text-right" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getNumber(
                                              _vm.total.sub - _vm.total.discount
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.total.taxes.vat.inclusive > 0 && _vm.foundTaxes
                              ? _c("div", { staticClass: "section row m-0" }, [
                                  _c("div", { staticClass: "label mb-2" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("message.totalexcludingvat")
                                        ) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "detail mb-2 text-right" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getNumber(_vm.total.untaxed)
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.taxResults, function(tax, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "section row m-0" },
                                [
                                  _c("div", { staticClass: "label mb-2" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(tax.displayText) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "detail mb-2 text-right" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.getNumber(tax.total)) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "section row m-0" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.grandtotal")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "detail text-right" }, [
                                _c(
                                  "span",
                                  { staticClass: "text-underline-border" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.getNumber(_vm.total.grand)) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            "signature",
                            { "non-fixed-bottom": !_vm.isFixedSignatureBottom }
                          ]
                        },
                        [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { staticClass: "title max-line-1" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.purchase.vendor.vendor_name) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info" }, [
                              _c("div", { staticClass: "name" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.name")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "date" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.date")) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "right" }, [
                            _c("div", { staticClass: "title max-line-1" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.shopInfo.shop_name) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info" }, [
                              _c("div", { staticClass: "name" }, [
                                _c("p", { staticStyle: { margin: "0" } }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("message.name")) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.shopInfo.shop_id ===
                                "63d8813021671ace1eb7269b"
                                  ? _c("p", { staticStyle: { margin: "0" } }, [
                                      _vm._v(
                                        "\n                    ด้วยความเคารพ\n                  "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "date" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.date")) +
                                    "\n                "
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        }
      ),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { width: "10px" } }, [_c("b", [_vm._v("#")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b8db09e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8db09e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/purchases/po/include/PrintPurchase.vue
// module id = null
// module chunks = 